<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qT35nf/tc-custom/9781250033987.jpg?1719575726469" alt="This image is the cover for the book You Can Trust Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Can Trust Me
      </h1>
      <p class="bookDescription body article font2">
        <b>In this domestic thriller by the author of <i>Close My Eyes</i>, a woman suspects a friend’s death is tied to her sister’s murder eighteen years ago.</b><br/><br/>On a quiet, sunny Sunday morning, Livy arrives at her best friend Julia’s apartment for a lunch date only to find her dead. Though all the evidence supports it, Livy cannot accept the official ruling of suicide; the Julia she remembers was loud, inappropriate, joyful, outrageous and loving, not depressed. The suspicious circumstances cause Livy to dig further, and she is suddenly forced to confront a horrifying possibility: that Julia was murdered, by the same man who killed Livy’s sister, Kara, eighteen years ago.<br/><br/>Desperate to understand the tragedies of her past and hold her unraveling life together, Livy throws herself into the search for Kara and Julia’s killer, who she now believes is someone close to her family. But if that is true, can she still trust anyone? Damien, the man Julia was secretly dating? Leo, her husband’s boss and a close family friend? His son Paul, her husband’s best mate since college? Or even Will, her own dear husband, who has betrayed her perhaps one time too many?<br/><br/>And when Livy finally faces her sister’s killer, and he traps her with one horrible, impossible choice, she must finally decide: is she strong enough to trust herself?<br/><br/><b>Praise for <i>You Can Trust Me</i></b><br/><br/>“An utterly engaging, twisty, and suspenseful thriller. Sophie McKenzie delivers an exciting, involving read. . . . Don’t miss it!” —Lisa Unger, author of <i>Beautiful Lies</i> and <i>Heartbroken</i><br/><br/>“Another intense thriller. . . . McKenzie ups her game in this one.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sophie McKenzie
      </h2>
      
      <p class="authorDescription body article"><P>SOPHIE MCKENZIE is the bestselling author of more than fifteen novels for children and teens in the UK, including the award winning <I>Girl, Missing</I> and <I>Sister, Missing</I>. She has won numerous awards, was one of the first Richard and Judy children's book club winners, and has twice been longlisted for the prestigious Carnegie Medal. She made her US adult debut with <I>Close My Eyes</I>. McKenzie lives in London and writes full-time.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b272405